module.exports = __webpack_public_path__ + "static/media/Plus.d1e2491e.svg";